import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'


Vue.use(Router)

let routes = [{
    path: '/login',
    name: 'Login',
    component: resolve => require(['@/views/login.vue'], resolve),
    meta: {
      title: '账号登录',
    }
  },
  {
    path: '/',
    name: 'Index',
    component: resolve => require(['@/views/index.vue'], resolve),
    meta: {
      title: '订单核销',
      auth: true,
    }
  },
  {
    path: '/history',
    name: 'History',
    component: resolve => require(['@/views/history.vue'], resolve),
    meta: {
      title: '3天内核销历史',
      auth: true,
    }
  },
  {
    path: '/shop_pos',
    name: 'ShopPos',
    component: resolve => require(['@/views/shop_pos.vue'], resolve),
    meta: {
      title: '线下优惠券核销',
      auth: true,
    }
  },
  {
    path: '/shop_pos_list',
    name: 'ShopPosList',
    component: resolve => require(['@/views/shop_pos_list.vue'], resolve),
    meta: {
      title: '已核销优惠券',
      auth: true,
    }
  },
  /*
  {
    path: '/printer',
    name: 'Printer',
    component: resolve => require(['@/views/printer.vue'], resolve),
    meta: {
      title: '连接打印机',
      auth: true,
    }
  },
  */
  {
    path: '/printer',
    name: 'Printer',
    component: resolve => require(['@/views/printer1.vue'], resolve),
    meta: {
      title: '连接打印机',
      auth: true,
    }
  },
  {
    path: '/center',
    name: 'Center',
    component: resolve => require(['@/views/center.vue'], resolve),
    meta: {
      title: '个人中心',
      auth: true,
    }
  },
  {
    path: '/pd_list',
    name: 'PdList',
    component: resolve => require(['@/views/pd_list.vue'], resolve),
    meta: {
      title: '可核销产品一览',
      auth: true,
    }
  },
  {
    path: '/product_info',
    name: 'ProductInfo',
    component: resolve => require(['@/views/product_info.vue'], resolve),
    meta: {
      title: '产品经理',
      auth: true,
    }
  },
  {
    path: '/update_pwd',
    name: 'UpdatePwd',
    component: resolve => require(['@/views/update_pwd.vue'], resolve),
    meta: {
      title: '修改密码',
      auth: true,
    }
  },
  {
    path: '/forget_password',
    name: 'ForgetPwd',
    component: resolve => require(['@/views/forget_password.vue'], resolve),
    meta: {
      title: '忘记密码'
    }
  }
]

const router = new Router({
  mode: process.env.IS_WEB === 1 ? 'history' : 'hash',
  routes
})

router.beforeEach(async (route, redirect, next) => {
  store.commit('SET_ENTRY_ROUTE', route.name)
  
  if (route.meta.auth === true) {
    const token = store.state.user.token

    if (token === null) {
      next({ name: 'Login' })
      return
    }
    else {
      //const rsp = await store.dispatch('GetUserInfo')

      //if (!rsp) {
      //  next({ name: 'Login' })
      //  return
      //}
    }
  }
  const title = route.meta.title || window.document.title
  store.commit('SET_TITLE', title)
  window.document.title = title
  
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js